export const ExternalMessages = {
    SUMMARY_CONTINUE: "SUMMARY_CONTINUE",
    ABORT_CONFIGURATION: "ABORT_CONFIGURATION",
};
